import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export const enum LOG_LEVELS {
  DEBUG = 2,
  INFORMATION = 1,
  ERROR = 0,
}

@Injectable({
  providedIn: 'root',
})
export class LogService {
  constructor() {
    throw Error("DO NOT CALL LogService C'TOR!!!")
  }

  static logError(message: string, error?: any): void {
    if (environment.log_level >= LOG_LEVELS.ERROR && !environment.production)
      console.error(`[ERROR] ${message}`, error);
    // You can send this error to your backend or any logging service here
  }

  static logInfo(...message: any): void {
    // if (environment.log_level >= LOG_LEVELS.INFORMATION && !environment.production)
    //   console.log(`[INFO]`, message);
  }

  static logDebug(message: string, value?: any): void {
    if (environment.log_level >= LOG_LEVELS.DEBUG && !environment.production) {
      if (!!value) {
        console.log(`[DEBUG] ${message}`, value);
      } else {
        console.log(`[DEBUG] ${message}`);
      }
    }
  }
}
